import { Disclosure } from '@headlessui/react';
import { IconAngleDown, IconAngleUp } from '@iwoca/icons';
import { FormattedMessage, useIntl } from 'react-intl';

import messages from './InterestOnly.messages';
import styles from './InterestOnlyPaymentsAccordion.module.css';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';
import { DrawdownRepaymentSchedule } from '../../../MyOffers.types';

export const InterestOnlyPaymentsAccordion = ({
    interestOnlyPeriod,
    interestOnlySchedule
}: {
    interestOnlyPeriod: number;
    interestOnlySchedule: DrawdownRepaymentSchedule['schedule'] | null;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.container}>
            <Disclosure>
                {({ open }) => (
                    <>
                        <Disclosure.Button className={styles.accordionButton}>
                            <span className={styles.wrapText}>
                                <FormattedMessage
                                    id="_.interest_only.repayment_breakdown.heading"
                                    defaultMessage="Interest-only repayments (months 1 - {interestOnlyPeriod})"
                                    values={{
                                        interestOnlyPeriod: interestOnlyPeriod
                                    }}
                                />
                            </span>
                            <span className={styles.showDetails}>
                                {open
                                    ? intl.formatMessage(
                                          messages.hideDetailsLabel
                                      )
                                    : intl.formatMessage(
                                          messages.showDetailsLabel
                                      )}

                                {open ? (
                                    <IconAngleUp className={styles.icon} />
                                ) : (
                                    <IconAngleDown className={styles.icon} />
                                )}
                            </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className={styles.accordionPanel}>
                            {interestOnlySchedule && (
                                <InterestOnlyPaymentsDetails
                                    interestOnlyPeriod={interestOnlyPeriod}
                                    interestOnlySchedule={interestOnlySchedule}
                                />
                            )}
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div>
    );
};

export const InterestOnlyPaymentsDetails = ({
    interestOnlyPeriod,
    interestOnlySchedule
}: {
    interestOnlyPeriod: number;
    interestOnlySchedule: DrawdownRepaymentSchedule['schedule'];
}) => {
    const intl = useIntl();

    return (
        <>
            <SummaryRow>
                <span>
                    {intl.formatMessage(messages.interestOnlyPeriodLabel)}
                </span>
                <span>
                    <FormattedMessage
                        {...messages.interestOnlyPeriodDuration}
                        values={{
                            duration: interestOnlyPeriod
                        }}
                    />
                </span>
            </SummaryRow>

            {interestOnlySchedule.map((schedule, index) => (
                <SummaryRow key={schedule.date}>
                    <span>
                        <FormattedMessage
                            {...messages.monthLabel}
                            values={{
                                monthNumber: index + 1
                            }}
                        />
                    </span>
                    <MoneyWithDecimals value={schedule.total} />
                </SummaryRow>
            ))}
        </>
    );
};
